export const GET_TAGS = 'GET_TAGS'
export const GET_LIST = 'GET_LIST'
export const GET_LOGIN_STATUS = 'GET_LOGIN_STATUS'



// WEBPACK FOOTER //
// ./src/store/action-types.js